import { createFileRoute } from '@tanstack/react-router';
import { ComparePage } from '@/features/public/ComparePage';
import { publicHead } from '@/features/public/PublicLayout';
import { parseSlugList } from '@/features/public/filters';

interface CompareSearch {
  ids?: string[];
}

export const Route = createFileRoute('/explore/compare')({
  validateSearch: (search: Record<string, unknown>): CompareSearch => {
    const ids = parseSlugList(search.ids);
    return ids ? { ids } : {};
  },
  head: () => publicHead('Compare listings', 'Side by side comparison of published listings.'),
  component: CompareRoute,
});

function CompareRoute() {
  const { ids = [] } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ComparePage
      slugs={ids}
      onRemove={(slug) => {
        const next = ids.filter((s) => s !== slug);
        void navigate({ search: next.length > 0 ? { ids: next } : {}, replace: true });
      }}
    />
  );
}
